import { colorPurple, fontWeightStrong } from '@atlas-frontend/design-tokens';
import styled from 'styled-components';

export const PurpleString = styled.span`
  font-weight: ${fontWeightStrong};
  color: ${colorPurple[6]};
`;
